import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Search_records extends PureComponent {
  render() {
    return (
      <div className="row" id="search_records">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Search Records</h2>
              <p>
                The Search Record function allows you to query and scroll
                through all records in an object type. By default, the Search
                Record function returns 20 records. You can change this with the{" "}
                <strong>size</strong> property. The upper <strong>size</strong>{" "}
                limit is 10,000 record per request. Search results by default
                start at position 0. You can change this using the{" "}
                <strong>from</strong> parameter.
              </p>
              <p>
                Field output can be set using the <strong>output</strong>{" "}
                parameter. The <strong>output</strong> property is a text array
                which supports top-level and top-level path field names.
              </p>
              <p>
                Sorting can be changed using the Elasticsearch 6.x syntax (see
                example 2). Default sorting is on the <strong>score</strong>{" "}
                parameter. The <strong>score</strong> parameter is automatically
                generated in search results and represents the significance of a
                free text search match. Easticserach does not support sorting
                words alphabetically.
              </p>
              <p>
                Free text scoring in ElasticSearch is based on a word existing
                in a text field and its weighting of the number of occurrences
                in the date object data set. For example if your data set is
                made up of standard English language and you search for the word
                “the” (the most common word in the English language) it will
                return records which contain the word “the” but it will give
                them a relatively low score compared to a less common word like
                “elephant”.
              </p>
              <p>
                ElasticSearch’s strength over traditional databases is the
                ability to query and index text efficiently. With this comes the
                ability to do complex text analysis with weightings across
                multiple text fields.
              </p>
              <p>
                The Nexoid search API has a built-in scroll function. Scrolling
                is when you start a search with many results and return them to
                the client in parts. This is useful for saving bandwidth or if
                you need to export more than 10,000 records. Scrolling works by
                performing a normal search query with the{" "}
                <strong>scroll</strong> parameter set to true. The query will
                return the first set of results and a Scroll ID. To request the
                next part of your search request, pass the Scroll ID to the
                Search Record function. Scrolls by default last for a rolling
                expiry of 15 minutes.
              </p>
              <p>
                The <strong>query</strong> parameter allows you to filter your
                results. Querying is based on Elasticsearch 6.x syntax.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Search Records Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple Search</h3>
              <p>
                This example is a simple search with no queries or filters and
                by default is limited to 20 records returned.
              </p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>/search
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                </div>
                <div>&#125;</div>
              </div>
              <p>
                The response shows that the search request took 3 milliseconds
                did not timeout. The records result only show one result, which
                has the ID of 454 and a score of 1. The score value gives you an
                indication of how closely the result matches your query
                criteria. In this example, we have no query, so the result score
                is 1.
              </p>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"took"</span>:{" "}
                  <span className="jsonP">3</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"timeout"</span>:{" "}
                  <span className="jsonP">false</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"total"</span>:{" "}
                  <span className="jsonP">1</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"records"</span>: [
                </div>
                <div className="i2">&#123;</div>
                <div className="i3">
                  <span className="jsonG">"id"</span>:{" "}
                  <span className="jsonY">"454"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"score"</span>:{" "}
                  <span className="jsonP">1</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"record"</span>: &#123;
                </div>
                <div className="i4">
                  <span className="jsonG">"text_name"</span>:{" "}
                  <span className="jsonY">"Meet Greg Smith"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"object_created_by"</span>: &#123;
                </div>
                <div className="i5">
                  <span className="jsonG">"text_first_name"</span>:{" "}
                  <span className="jsonY">"John"</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"text_last_name"</span>:{" "}
                  <span className="jsonY">"Smith"</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"text_username"</span>:{" "}
                  <span className="jsonY">"JOHN"</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"date_created"</span>:{" "}
                  <span className="jsonY">"2016-03-08T13:04:16.069Z"</span>
                </div>
                <div className="i4">&#125;,</div>
                <div className="i4">
                  <span className="jsonG">"object_updated_by"</span>: &#123;
                </div>
                <div className="i5">
                  <span className="jsonG">"text_first_name"</span>:{" "}
                  <span className="jsonY">"John"</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"text_last_name"</span>:{" "}
                  <span className="jsonY">"Smith"</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"text_username"</span>:{" "}
                  <span className="jsonY">"JOHN"</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"date_created"</span>:{" "}
                  <span className="jsonY">"2016-03-08T13:42:10.852Z"</span>
                </div>
                <div className="i4">&#125;</div>
                <div className="i3">&#125;</div>
                <div className="i2">&#125;</div>
                <div className="i1">]</div>
                <div>&#125;</div>
              </div>
            </section>
            <section>
              <h3>Example 2: Filter, Order by, Output, Pagination, Size</h3>
              <p>
                This example filters all records where text_state equals
                “open”. The results are then sorted by date created in
                descending order (most recent record first). When returning the
                results, it skips the first 10 records and returns the next 20.
                The records returned only contain one field (text_name).
              </p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>/search
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"query"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"term"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"text_state"</span>:{" "}
                  <span className="jsonY">"open"</span>
                </div>
                <div className="i2">&#125;</div>
                <div className="i1">&#125;,</div>
                <div className="i1">
                  <span className="jsonG">"sort"</span>: [
                </div>
                <div className="i2">&#123;</div>
                <div className="i3">
                  <span className="jsonG">
                    "object_created_by.date_created"
                  </span>
                  : &#123;
                </div>
                <div className="i4">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonY">"desc"</span>
                </div>
                <div className="i3">&#125;</div>
                <div className="i2">&#125;</div>
                <div className="i1">],</div>
                <div className="i1">
                  <span className="jsonG">"output"</span>: [
                </div>
                <div className="i2">
                  <span className="jsonY">"text_name"</span>
                </div>
                <div className="i1">],</div>
                <div className="i1">
                  <span className="jsonG">"from"</span>:{" "}
                  <span className="jsonP">0</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"size"</span>:{" "}
                  <span className="jsonP">20</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>

            <section>
              <h3>Example 3: Scrolling</h3>
              <p>
                In the first scroll query we added the parameter scroll = true.
                The query performs as usual in addition to returning a
                scroll_id.
              </p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>/search
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"scroll"</span>:{" "}
                  <span className="jsonP">true</span>
                </div>
                <div>&#125;</div>
              </div>
              <p>The response includes a Scroll ID.</p>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"took"</span>:{" "}
                  <span className="jsonP">6</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"timeout"</span>:{" "}
                  <span className="jsonP">false</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"total"</span>:{" "}
                  <span className="jsonP">10</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"records"</span>: [ ... ],
                </div>
                <div className="i1">
                  <span className="jsonG">"scroll_id"</span>:{" "}
                  <span className="jsonY">
                    "DnF1ZXJ5VGhlbkZldGNoBQAAAu2VFnltem55Z3AtN"
                  </span>
                </div>
                <div>&#125;</div>
              </div>

              <p>
                To retrieve the next batch add the scroll_id to the request. You
                can keep resending this request until you have scrolled through
                the entire data set.
              </p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>/search
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"scroll_id"</span>:{" "}
                  <span className="jsonY">
                    "DnF1ZXJ5VGhlbkZldGNoBQAAAu2VFnltem55Z3AtN"
                  </span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Search_records;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Search_records.js